import { useQuery } from '@tanstack/react-query'
import navigationDummy from '../../../dataContainer/navigationData.json'
import SearchResultDummy from '../../../dataContainer/searchResultData.json'
import { RootNavigation, SearchResult } from './Types';

//TODO: update me, when api will be written
const getNavigation = (): Promise<RootNavigation[]> => {
  return Promise.resolve(navigationDummy)
}

export const useNavigationQuery = () => {
  return useQuery<RootNavigation[], { message: string }>(['navigation'], getNavigation)
}

const getSearchResult = (): Promise<SearchResult> => {
  return Promise.resolve(SearchResultDummy)
}

export const useResultSearchQuery = (searchWords: string) => {
  return useQuery<SearchResult, { message: string }>(['searchResult'], getSearchResult)
}
